<template>
    <div class="underline-tabs" :class="{ 'underline-tabs--dense': dense, 'underline-tabs--top': topBorder }">
        <button v-for="item in items" :key="item[itemValue]" type="button" class="underline-tab"
            :class="{ active: value === item[itemValue] }" @click="onClick(item)">
            {{ item[itemText] }}
            <v-icon v-if="isLocked(item)" size="13" class="ml-1">mdi-lock-outline</v-icon>
        </button>
    </div>
</template>

<script>
export default {
    name: "UnderlineTabs",
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        value: {
            type: [String, Number],
            default: null,
        },
        itemText: {
            type: String,
            default: 'name',
        },
        itemValue: {
            type: String,
            default: 'value',
        },
        dense: {
            type: Boolean,
            default: false,
        },
        topBorder: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        isLocked(item) {
            return !!item?.feature && !this.can(item.feature)
        },
        onClick(item) {
            const vm = this
            if (vm.isLocked(item)) return vm.requirePlan(item.feature)
            vm.$emit('change', item[vm.itemValue])
        },
    },
}
</script>

<style scoped>
.underline-tabs {
    display: flex;
    align-items: flex-end;
    padding: 0 24px;
    border-bottom: 1px solid var(--v-outline-base);
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.underline-tabs--top {
    border-top: 1px solid var(--v-outline-base);
}

.underline-tabs::-webkit-scrollbar {
    display: none;
}

.underline-tab {
    flex: 0 0 auto;
    padding: 12px 20px;
    margin-bottom: -1px;
    background: transparent;
    border-bottom: 2px solid transparent;
    font-family: inherit;
    font-size: var(--fs-label);
    font-weight: 600;
    white-space: nowrap;
    color: var(--v-txtMuted-base);
    transition: color 0.15s, border-color 0.15s;
}

.underline-tab:hover {
    color: var(--v-txtSecondary-base);
}

.underline-tab.active {
    color: var(--v-txtPrimary-base);
    border-bottom-color: var(--v-primary-base);
}

.theme--light .underline-tab.active {
    border-bottom-color: var(--v-accent-base);
}

.underline-tabs--dense .underline-tab {
    padding: 10px 16px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.07em;
}

@media (max-width: 600px) {
    .underline-tabs {
        padding: 0 12px;
    }

    .underline-tab {
        padding: 12px 14px;
    }

    .underline-tabs--dense .underline-tab {
        padding: 10px 12px;
    }
}
</style>
